import tw from "twin.macro";
const FormGrid = tw.div`grid grid-cols-1 gap-6`;
export default FormGrid;
